import styled from '@emotion/styled';

export const MainBlock = styled.div`
  font-family: 'SF Pro Text', serif;
  font-weight: 500;
  font-size: 28px;
  line-height: 100%;
  letter-spacing: 0%;
`;
